<template>
  <div v-if="stype === 'row'" class="row">
    <div class="col-lg-6 col-md-6">
      <div class="business-post-thumb">
        <img :src="datas.coverurl" alt="feature" />
      </div>
    </div>
    <div class="col-lg-6 col-md-6">
      <div class="trending-news-item">
        <div class="trending-news-content">
          <div class="post-meta">
            <div class="meta-categories">
              <router-link :to="`/articles/${datas.id}`">
                {{ datas.channel }}
              </router-link>
            </div>
            <div class="meta-date">
              <span>{{ datas.createdat }}</span>
            </div>
          </div>
          <h3 class="title">
            <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
          </h3>
          <p class="text ellipsis-3-lines">
            {{ datas.summary }}
          </p>
          <router-link v-if="readMore" :to="`/articles/${datas.id}`">查看更多</router-link>
        </div>
      </div>
    </div>
  </div>
  
  <div v-else-if="stype === 'row-style-2'" class="bussiness-post-item">
    <div class="bussiness-post-thumb">
      <img
        :src="datas.coverurl"
        alt="business"
      />
    </div>
    <div class="bussiness-post-content">
      <h3 class="title">
        <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
      </h3>
      <div class="meta-date-link">
        <span>{{ datas.createdat }}</span>
        <router-link :to="`/articles/${datas.id}`">
          {{ datas.channel }}
        </router-link>
        <ul>
          <li>
            <a href="#"><i class="fal fa-bookmark"></i></a>
          </li>
          <li>
            <a href="#"><i class="fas fa-share"></i></a>
          </li>
        </ul>
      </div>
      <p>
        {{ datas.article }}
      </p>
      <a href="#">LEARN MORE <img src="@/assets/images/arrow-2.svg" alt=""/></a>
    </div>
  </div>

  <div v-else-if="stype === 'col'" class="trending-news-item">
    <div class="trending-news-thumb"
      v-if="datas.coverurl"
      :style="{
        backgroundImage: `url(${datas.coverurl})`,
      }"    
    >
    </div>
    <div class="trending-news-content">
      <div class="post-meta">
        <div class="meta-categories" v-if="datas.channel">
          <router-link :to="`/articles/${datas.id}`">{{ datas.channel }}</router-link>
        </div>
        <div class="meta-date">
          <span>{{ datas.createdat }}</span>
        </div>
      </div>
      <h3 class="title">
        <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
      </h3>
      <p class="text ellipsis-3-lines">
        {{ datas.summary }}
      </p>
      <router-link v-if="readMore" :to="`/articles/${datas.id}`">Read more</router-link>
    </div>
  </div>

  <div v-else-if="stype === 'col-style-2'" class="finance-item">
    <div class="finance-thumb">
      <img
        :src="datas.coverurl"
        alt="finance"
      />
      <div class="finance-date">
        <span>{{ datas.channel }}</span>
      </div>
    </div>
    <div class="finance-content">
      <h3 class="title">
        <router-link to="/posts/postOne">{{ datas.title }}}</router-link>
      </h3>
      <p class="line-clumb">
        {{ datas.article }}
      </p>
      <ul>
        <li>
          <a href="#"><i class="far fa-eye"></i> 53,346</a>
        </li>
        <li>
          <a href="#"><i class="far fa-heart"></i> 53,346</a>
        </li>
        <li>
          <a href="#"><i class="fas fa-share"></i> 53,346</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      type: Object,
    },
    readMore: {
      type: Boolean,
      default: false,
    },
    stype: {
      type: String,
    },
  },
};
</script>

<style scoped>

.trending-news-thumb {
  width: 100%;
  height: 220px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* iPad 等平板设备常见宽度范围，一般竖屏 768px，横屏 1024px */
@media (min-width: 768px) and (max-width: 1024px) {
  .trending-news-thumb {
    /* 调整高度，可根据实际需求修改 */
    height: 180px; 
  }
}

.text.ellipsis-3-lines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 最多显示 3 行 */
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
